import { JobDetailsTypes } from '../ActionTypes/JobDetailsTypes';

class CustomerActions {
  static getJobDetails = payload => {
    return {
      type: JobDetailsTypes.GET_JOB_DETAILS,
      payload: payload,
    };
  };

  static clearJobDetails = () => {
    return {
      type: JobDetailsTypes.CLEAR_JOB_DETAILS,
    };
  };
}

export default CustomerActions;
